// Curated names for color sets, keyed by the gradient's / palette's colours.
//
// The key is the set of hex colours a gradient (or palette) contains, normalised
// the same way every time: lowercased, '#'-stripped, SORTED, joined by '-'. Sorting
// makes the lookup order-independent, so a gradient and its reverse share a name and
// the same table also serves the palette tool (a palette is just a colour set).
//
// Source: open data only (uiGradients, MIT — https://github.com/Ghosh/uiGradients).
// We do not invent names. New open-data sources can be merged in over time.
//
// Look up via ColorService.getColorSetName( hexes ).
export const GRADIENT_NAMES: { [ colorSet: string ]: string } = {
  '2c3e50-bdc3c7': '50 Shades of Grey',
  '2f0743-41295a': '80\'s Purple',
  'de6262-ffb88c': 'A Lost Memory',
  '0083fe-00fff0': 'Abbas',
  '70e2ff-9fff5b-cd93ff-ff75c3-ffa647-ffe83f': 'After the Rain',
  '000c40-607d8b': 'Afternoon',
  '1fddff-ff4b1f': 'Ali',
  'db36a4-f7ff00': 'Alihossein',
  'bd3f32-cb356b': 'Alive',
  'ddd6f3-faaca8': 'Almost',
  '023c0d-0c0c6d-5bb226-98d0c1-de512b': 'Ameena',
  '6e48aa-9d50bb': 'Amethyst',
  '4a00e0-8e2de2': 'Amin',
  '9796f0-fbc7d4': 'Anamnisar',
  'd70652-ff025e': 'Andreuzza\'s',
  '334d50-cbcaa5': 'Anwar',
  '1a2980-26d0ce': 'Aqua Marine',
  '50c9c3-96deda': 'Aqualicious',
  '03001e-7303c0-ec38bc-fdeff9': 'Argon',
  '414d0b-727a17': 'Army',
  '3f4c6b-606c88': 'Ash',
  '4bc0c8-c779d0-feac5e': 'Atlas',
  '61045f-aa076b': 'Aubergine',
  'b0dab9-dad299': 'Autumn',
  '7f7fd5-86a8e7-91eae4': 'Azur Lane',
  '89fffd-ef32d9': 'Azure Pop',
  '00c9ff-92fe9d': 'Back To Earth',
  'c02425-f0cb35': 'Back to the Future',
  '061700-52c234': 'Behongo',
  '1e90ff-f9c942-ff1e56': 'Beleko',
  '2c3e50-3498db': 'Between Night and Day',
  '373b44-73c8a9': 'Between The Clouds',
  '4b134f-c94b4b': 'Bighead',
  'f4c4f3-fc67fa': 'Black Rosé',
  '29eac4-4284db': 'Bleem',
  'e73827-f85032': 'Blood Red',
  'dd2476-ff512f': 'Bloody Mary',
  'e65c00-f9d423': 'Blooker20',
  '4b859e-6da6be-6da6be': 'Blooze',
  '00416a-e4e5e6': 'Blu',
  '0085ca-fd8112': 'Blue & Orange',
  '0083b0-00b4db': 'Blue Raspberry',
  '36b1c7-960b33': 'Blue Red',
  '2f80ed-56ccf2': 'Blue Skies',
  '2b2c49-b5b9ff': 'Blue Slate',
  '0052d4-4364f7-6fb1fc': 'Bluelagoo',
  'cbad6d-d53369': 'Blurry Beach',
  'b24592-f15f79': 'Blush',
  '2bc0e4-eaecc6': 'Bora Bora',
  'ec6f66-f3a183': 'Bourbon',
  '00c3ff-ffff1c': 'Brady Brady Fun Fun',
  '00d2ff-928dab': 'Bright Vault',
  'd9a7c7-fffcdc': 'Broken Hearts',
  'ff416c-ff4b2b': 'Burning Orange',
  '009fff-ec2f4b': 'By Design',
  '49a09d-5f2c82': 'Calm Darya',
  '4568dc-b06ab3': 'Can You Feel The Love Tonight',
  'bfe6ba-d3959b': 'Candy',
  '1d2671-c33764': 'Celestial',
  '556270-ff6b6b': 'Cheer Up Emo Kid',
  'eb3349-f45c43': 'Cherry',
  'bb377d-fbd3e9': 'Cherryblossoms',
  '007991-78ffd6': 'Chitty Chitty Bang Bang',
  '2f7336-aa3a38': 'Christmas',
  '4ac29a-bdfff3': 'Cinnamint',
  'f37335-fdc830': 'Citrus Peel',
  '005c97-363795': 'Clear Sky',
  'ece9e6-ffffff': 'Clouds',
  '000000-eb5757': 'Coal',
  '1cefff-c0c0aa': 'Cocoaa Ice',
  '554023-c99846': 'Coffee Gold',
  'cfdef3-e0eafc': 'Colors Of Sky',
  '00416a-799f0c-ffe000': 'Combi',
  'ef3b36-ffffff': 'Compare Now',
  '056b3b-516b8b': 'Compass',
  '603813-b29f94': 'Cool Brown',
  '2980b9-6dd5fa-ffffff': 'Cool Sky',
  '94716b-b79891': 'Copper',
  '333399-ff00cc': 'Cosmic Fusion',
  'a83279-d38312': 'Crazy Orange I',
  '642b73-c6426e': 'Crimson Tide',
  '155799-159957': 'Crystal Clear',
  '3d72b4-525252': 'Curiosity blue',
  'f9d423-ff4e50': 'Dance To Forget',
  '7bc6cc-be93c5': 'Dania',
  '004680-4484ba': 'Dark Blu Two',
  '002e5d-002e5d-2774ae': 'Dark Blue Gradient',
  '181818-ba8b02': 'Dark Knight',
  '373b44-4286f4': 'Dark Ocean',
  '283e51-4b79a1': 'Dark Skies',
  '3b4371-f3904f': 'Dawn',
  'f857a6-ff5858': 'Day Tripper',
  '4ca1af-c4e0e5': 'Decent',
  '512da8-673ab7': 'Deep Purple',
  '2c3e50-4ca1af': 'Deep Sea Space',
  '000000-434343': 'Deep Space',
  'd3cce3-e9e4f0': 'Delicate',
  '74ebd5-acb6e5': 'Digital Water',
  'ec008c-fc6767': 'DIMIGO',
  '8ca6db-b993d6': 'Dirty Fog',
  '4ecdc4-556270': 'Disco',
  '4a569d-dc2424': 'Dracula',
  'c9d6ff-e2e2e2': 'Dull',
  '2c3e50-fd746c': 'Dusk',
  '96e6a1-d4fc79': 'Dusty Grass',
  '649173-dbd5a4': 'Earthly',
  '45b649-dce35b': 'EasyMed',
  'feb47b-ff7e5f': 'Ed\'s Sunset Gradient',
  '43add0-8bdeda-998ee0-e17dc2-ef9393': 'Elate The Euge',
  '0000cd-228b22-8a2be2-ccff00': 'Electric Peacock',
  '4776e6-8e54e9': 'Electric Violet',
  '05386b-5cdb95': 'Emerald Sea',
  '348f50-56b4d3': 'Emerald Water',
  '185a9d-43cea2': 'Endless River',
  '005aa7-fffde4': 'Evening Night',
  '1565c0-b92b27': 'Evening Sunshine',
  '3c1053-ad5389': 'eXpresso',
  '0072ff-00c6ff': 'Facebook Messenger',
  '4b0082-9400d3': 'Farhan',
  'cb2d3e-ef473a': 'Firewatch',
  'fdcf58-ff0000': 'Flame',
  'f12711-f5af19': 'Flare',
  '33001b-ff0084': 'Flickr',
  'cc86d1-dcffbd': 'Flower',
  '2c7744-5a3f37': 'Forest',
  '5d4157-a8caba': 'Forever Lost',
  '135058-f1f2b5': 'Fresh Turboscent',
  '83a4d4-b6fbff': 'Friday',
  '004e8f-72c6ef': 'From Ice To Fire',
  '000428-004e92': 'Frost',
  '403b4a-e7e9bb': 'Frozen',
  '904e95-e96443': 'Grapefruit Sunset',
  '64b3f4-c2e59c': 'Green and Blue',
  '00cdac-02aab0': 'Green Beach',
  '141517-6a9113': 'Green to dark',
  'fd746c-ff9068': 'Haikus',
  '16a085-f4d03f': 'Harmonic Energy',
  '1f4037-99f2c8': 'Harvey',
  '77a1d3-79cbca-e684ae': 'Hazel',
  '1e130c-9a8478': 'Hersheys',
  '43c6ac-f8ffae': 'Honey Dew',
  '003973-e5e5be': 'Horizon',
  'e44d26-f16529': 'Html',
  '0082c8-0082c8-667db6-667db6': 'Hydrogen',
  '0a2a88-59cde9': 'Hyper Blue',
  'ee0979-ff6a00': 'Ibiza Sunset',
  '00d9f5-00f5a0': 'Ibtesam',
  '3fada8-808080': 'IIIT Delhi',
  '457fca-5691c8': 'Inbox',
  '480048-c04848': 'Influenza',
  '833ab4-fcb045-fd1d1d': 'Instagram',
  '9733ee-da22ff': 'Intuitive Purple',
  'c5796d-dbe6f6': 'Jaipur',
  '0052d4-65c7f7-9cecfb': 'Jodhpur',
  'ddefbb-ffeeee': 'Jonquil',
  '1e3c72-2a5298': 'Joomla',
  '12c2e9-c471ed-f64f59': 'JShine',
  'ff8008-ffc837': 'Juicy Orange',
  '19547b-ffd89b': 'Jupiter',
  '516395-614385': 'Kashmir',
  '2948ff-396afc': 'Kimoby Is The New Blue',
  '1a2a6c-b21f1f-fdbb2d': 'King Yna',
  'd1913c-ffd194': 'Koko Caramel',
  '2ebf91-8360c3': 'Kye Meh',
  '6be585-dd3e54': 'Kyoo Pal',
  '544a7d-ffd452': 'Kyoo Tah',
  'c21500-ffc500': 'Kyoto',
  '0f0c29-24243e-302b63': 'Lawrencium',
  'f7971e-ffd200': 'Learning and Leading',
  '7ec6bc-ebe717': 'Lemon Lime',
  '3ca55c-b5ac49': 'Lemon Twist',
  '6025f5-ff5555': 'Lensod',
  'ed8f03-ffb75e': 'Light Orange',
  'a1ffce-faffd1': 'Limeade',
  '6d6027-d3cbb8': 'Lithium',
  '76b852-8dc26f': 'Little Leaf',
  '304352-d7d2cc': 'Lizard',
  '200122-6f0000': 'Love and Liberty',
  '3a6186-89253e': 'Love Couple',
  '20bdff-5433ff-a5fecb': 'Lunada',
  '56ab2f-a8e063': 'Lush',
  '59c173-5d26c1-a17fe0': 'Magic',
  '0ed2f7-b2fefa': 'Maldives',
  '061161-780206': 'Man of Steel',
  'ffa751-ffe259': 'Mango',
  '2ada53-de8a41': 'Mango Papaya',
  'edde5d-f09819': 'Mango Pulp',
  '24c6dc-514a9d': 'Mantle',
  'ffefba-ffffff': 'Margo',
  '24fe41-fdfc47': 'Martini',
  'eea849-f46b45': 'Master Card',
  '42275a-734b6d': 'Mauve',
  'c6ffdd-f7797d-fbd786': 'MegaTron',
  '8e44ad-c0392b': 'Mello',
  '3b8d99-6b6b83-aa4b6b': 'Memariani',
  '283c86-45a247': 'Meridian',
  'abbaab-ffffff': 'Metallic Toad',
  '659999-f4791f': 'Metapolis',
  '0abfbc-fc354c': 'Miaka',
  '4da0b0-d39d38': 'Miami Dolphins',
  '232526-414345': 'Midnight City',
  '4ca2cd-67b26f': 'Mild',
  '30e8bf-ff8235': 'Mini',
  'dc281e-f00000': 'Minimal Red',
  '5614b0-dbd65c': 'Minnesota Vikings',
  '16222a-3a6073': 'Mirage',
  '215f00-e4e4d9': 'Misty Meadow',
  '1d976c-93f9b9': 'Mojito',
  '7aa1d2-cc95c0-dbd4b4': 'Monte Carlo',
  '4e54c8-8f94fb': 'Moon Purple',
  '0f2027-203a43-2c5364': 'Moonlit Asteroid',
  'd6a4a4-dae2f8': 'Moonrise',
  '000000-152331': 'Moonwalker',
  '616161-9bc5c3': 'Moor',
  '134e5e-71b280': 'Moss',
  '757f9a-d7dde8': 'Mystic',
  '7a2828-a73737': 'Namn',
  'f2709c-ff9472': 'Nelson',
  '64965e-81ff8a': 'Neon Green',
  '12fff7-b3ffab': 'Neon Life',
  '2657eb-de6161': 'Nepal',
  '1f1c18-8e0e00': 'Netflix',
  'b91d73-f953c6': 'Neuromancer',
  '8a2be2-f8f8ff-ffa500': 'Newspaper',
  '2980b9-2c3e50': 'Nighthawk',
  '26a0da-314755': 'Nimvelo',
  'bfe9ff-ff6e7f': 'Noon to Dusk',
  '00b09b-96c93d': 'Ohhappiness',
  '091e3a-2d9ee0-2f80ed': 'Omolon',
  '3d7eaa-ffe47a': 'Opa',
  'ff5e62-ff9966': 'Orange Coral',
  'f7b733-fc4a1a': 'Orange Fun',
  '093637-44a08d': 'Orca',
  '0f3443-34e89e': 'Pacific Dream',
  'd6ae7b-eacda3': 'Pale Wood',
  '7b920a-add100': 'Parklife',
  'e35d5b-e53935': 'Passion',
  'ffb347-ffcc33': 'Pastel Orange at the Sun',
  'ed4264-ffedbc': 'Peach',
  'a8cecf-e6ae8c': 'Peach Sea',
  '666600-999966': 'Petrichor',
  '536976-bbd2c5': 'Petrol',
  'ee9ca7-ffdde1': 'Piglet',
  '800080-ffc0cb': 'Pink Flavour',
  'dd5e89-f7bb97': 'Pinky',
  '182848-4b6cb7': 'Pinot Noir',
  '114357-f29492': 'Pizelex',
  'd31027-ea384d': 'Playing with Reds',
  '2196f3-f44336': 'Politics',
  '403a3e-be5869': 'Poncho',
  '8e9eab-eef2f3': 'Portrait',
  '00223e-ffa17f': 'Predawn',
  '108dc7-ef8e38': 'Pun Yeta',
  '333333-dd1818': 'Pure Lust',
  '7f00ff-e100ff': 'Purpink',
  'c84e89-f15f79': 'Purple',
  '0b8793-360033': 'Purple Bliss',
  'a811da-bf5ae0': 'Purple Dream',
  '753a88-cc2b5e': 'Purple Love',
  '1d2b64-f8cdda': 'Purple Paradise',
  'ba5370-f4e2d8': 'Purple White',
  '20002c-cbb4d4': 'Purplepine',
  '6a3093-a044ff': 'Purplin',
  '11998e-38ef7d': 'Quepal',
  '3300fc-95008a-eb0000': 'Racker',
  'a770ef-cf8bf3-fdb99b': 'Radar',
  '00a651-72c6ef-f7941e': 'Radioactive Heat',
  '00f260-0575e6': 'Rainbow Blue',
  '1e9600-ff0000-fff200': 'Rastafari',
  '799f0c-acbb78': 'Reaqua',
  '000000-e74c3c': 'Red Mist',
  '1d4350-a43931': 'Red Ocean',
  '355c7d-6c5b7b-c06c84': 'Red Sunset',
  '00d2ff-3a7bd5': 'Reef',
  'b20a2c-fffbd5': 'Relaxing red',
  '3a1c71-d76d77-ffaf7b': 'Relay',
  '636fa4-e8cbc0': 'Rose Colored Lenses',
  '5fc3e4-e55d87': 'Rose Water',
  'ffafbd-ffc3a0': 'Roseanna',
  '141e30-243b55': 'Royal',
  '292e49-536976': 'Royal Blue',
  '292e49-536976-bbd2c5': 'Royal Blue + Petrol',
  '757519-ccccb2': 'Sage Persuasion',
  '3e5151-decba4': 'Sand to Blue',
  '36d1dc-5b86e5': 'Scooter',
  '1cd8d2-93edc7': 'Sea Blizz',
  '2b5876-4e4376': 'Sea Blue',
  '3cd3ad-4cb8c4': 'Sea Weed',
  '00467f-a5cc82': 'Sel',
  '3c3b3f-605c3c': 'Selenium',
  '29323c-485563': 'ServQuick',
  '2193b0-6dd5ed': 'Sexy Blue',
  'd66d75-e29587': 'Sha la la',
  '66ff00-a80077': 'Shahabi',
  '64f38c-f79d00': 'Sherbert',
  'bc4e9c-f80759': 'Shifter',
  '636363-a2ab58': 'Shifty',
  '70e1f5-ffd194': 'Shore',
  'e43a15-e65245': 'Shrimpy',
  '4389a2-5c258d': 'Shroom Haze',
  '93291e-ed213a': 'Sin City Red',
  'd4d3dd-efefbb': 'Sirius Tamed',
  '1488cc-2b32b2': 'Skyline',
  '3f2b96-a8c0ff': 'Slight Ocean View',
  'fffc00-ffffff': 'Snapchat',
  '06beb6-48b1bf': 'Socialive',
  '3a6073-3a7bd5': 'Solid Vault',
  'f83600-fe8c00': 'SoundCloud',
  '5c7852-9fa0a8': 'Space Light Green',
  '4b1248-f0c27b': 'Starfall',
  '1f1c2c-928dab': 'Steel Gray',
  '348ac7-7474bf': 'Stellar',
  '12d8fa-1fa2ff-a6ffcb': 'Stripe',
  '6a82fb-fc5c7d': 'Sublime Light',
  '3f5efb-fc466b': 'Sublime Vivid',
  '0cebeb-20e3b2-29ffc6': 'Subu',
  'cac531-f3f9a7': 'Sulphur',
  '22c1c3-fdbb2d': 'Summer',
  'abecd6-fbed96': 'Summer Breeze',
  '78ffd6-a8ff78': 'Summer Dog',
  'f8b500-fceabb': 'Sun on the Horizon',
  'f2994a-f2c94c': 'Sunkist',
  'e1f5c4-ede574': 'Sunny Days',
  'f09819-ff512f': 'Sunrise',
  '0b486b-f56217': 'Sunset',
  '0099f7-f11712': 'Superman',
  '834d9b-d04ed6': 'Suzy',
  'ff5f6d-ffc371': 'Sweet Morning',
  'ff4b1f-ff9068': 'Sylvia',
  '2e1437-948e99': 'Talking To Mice Elf',
  '23074d-cc5333': 'Taran Tado',
  '11ffbd-aaffa9': 'Teal Love',
  '1c92d2-f2fcfe': 'Telegram',
  '007fc3-5cb644-f36222': 'Telko',
  '000000-0f9b0f': 'Terminal',
  '191654-43c6ac': 'The Blue Lagoon',
  '004e8f-f7941e': 'The Sky And The Sea',
  '190a05-870000': 'The Strain',
  '00dbde-fc00ff': 'Timber',
  '283048-859398': 'Titanium',
  'eecda3-ef629f': 'Tranquil',
  '16bffd-cb3066': 'Transfile',
  '136a8a-267871': 'Turquoise flow',
  '2a0845-6441a5': 'Twitch',
  '009ffc-1da1f2': 'Twitter',
  '004ff9-fff94c': 'Ukraine',
  '654ea3-eaafc8': 'Ultra Voilet',
  '004d7a-008793-00bf72-051937-a8eb12': 'Under Blue Green',
  '093028-237a57': 'Under the Lake',
  'acf7f0-f0acf7-f7f0ac': 'Unicorn Rainbow',
  '89216b-da4453': 'Vanusa',
  '333333-e9d362': 'Vasily',
  'e1eec3-f05053': 'Velvet Sun',
  '6190e8-a7bfe8': 'Venice',
  '085078-85d8ce': 'Venice Blue',
  '799f0c-ffe000': 'Ver',
  'acbb78-f7f8f8': 'Ver Black',
  '021b79-0575e6': 'Very Blue',
  '3494e6-ec6ead': 'Vice City',
  '001510-00bf8f': 'Vine',
  'c9ffbf-ffafbd': 'Virgin',
  '7b4397-dc2430': 'Virgin America',
  '000046-1cb5e0': 'Visions of Grandeur',
  '003d4d-00c996': 'Visual Blue',
  '40e0d0-ff0080-ff8c00': 'Wedding Day Blues',
  '000c40-f0f2f0': 'What lies Beyond',
  '111111-4e2020-794747-b9a0a0-f7f7f7': 'Whinehouse',
  '86fde8-acb6e5': 'Windy',
  '274046-e6dada': 'Winter',
  '333333-a2ab58-a43931': 'Winter Woods',
  '8a2387-e94057-f27121': 'Wiretap',
  '240b36-c31432': 'Witching Hour',
  '493240-ff0099': 'Yoda',
  'b31217-e52d27': 'YouTube',
  '2a2d3e-fecb6e': 'Zenta',
  'ada996-dbdbdb-eaeaea-f2f2f2': 'Zinc',
};
